import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { AiOutlineClear } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';
import { useClientes } from '../../../../contexts/Clientes';
import { useEffectOnce } from 'react-use';
import { Button } from '../../../../themes/components/Button';

export const BuscaClientes = () => {
    let history = useHistory();
    const { buscarClientes } = useClientes();
    const [fieldCNPJ, setFieldCNPJ] = useState<string>("");
    const [fieldCliente, setFieldCliente] = useState<string>("");

    function handleBuscarCliente() {
        buscarClientes(fieldCliente, fieldCNPJ, history);
    }

    //Buscando os Clientes na primeira vez que a tela abrir, ainda sem filtro;
    useEffectOnce(() => {
        buscarClientes("", "", history);
    })

    function handleClearFields() {
        setFieldCliente("");
        setFieldCNPJ("");
    }

    const handleChangeFieldCNPJ = (event: React.ChangeEvent<{ value: unknown }>) => {
        setFieldCNPJ(event.target.value as string);
    };

    const handleChangeFieldCliente = (event: React.ChangeEvent<{ value: unknown }>) => {
        setFieldCliente(event.target.value as string);
    };

    return (
        <div className="cliente-campo-busca">
            <form>
                <div className="form-row">
                    <div className="form-line">
                        <div className="form-group">
                            <label htmlFor="user">Cliente</label>
                            <div className="cliente-linha-campo">
                                <input type="text" className="form-control" id="campo-cliente" name="campo-cliente" onChange={handleChangeFieldCliente} value={fieldCliente} placeholder="Código ou nome" />
                            </div>
                        </div>
                    </div>
                    <div className="form-line">
                        <div className="form-group">
                            <label htmlFor="consulta-combobox-tipo-cliente">CNPJ</label>
                            <div className="cliente-linha-campo">
                                <input type="text" className="form-control" id="campo-cnpj" name="campo-cnpj" onChange={handleChangeFieldCNPJ} value={fieldCNPJ} />
                            </div>
                        </div>
                    </div>
                    <div className="form-buttons">
                        <Button titleText="Pesquisar" classBtn="" onClick={() => handleBuscarCliente()} >
                            <FaSearch color="#444" style={{ marginBottom: '0.3em' }} />
                        </Button>
                        <Button titleText="Limpar campos" classBtn="" onClick={() => handleClearFields()} >
                            <AiOutlineClear color="#444" style={{ marginBottom: '0.3em' }} />
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    )
}